import React from 'react';
import {DialogContent, DialogTitle, withStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import {StackProps} from '../layout/layout.styled';
import {ContentSection} from './components/modal-sections.styled';

type HeadingSectionProps =
    & StackProps
    & {
    headingText: string
    labelText: string
}

// Backdrop
// box-shadow: 0 3px 16px 0 rgba(0,0,0,0.07);

export const HeadingSection = ({ headingText, labelText, ...restProps }: HeadingSectionProps) => {
    return (
        <ContentSection {...restProps}>
            <Heading>
                {headingText}
            </Heading>

            <Label>
                {labelText}
            </Label>
        </ContentSection>
    );
};

const Heading = styled(Typography).attrs({ variant: 'subtitle1' })`
  color: #666C79;
  font-size: 13px;
  font-weight: 400;
`;

const Label = styled(Typography).attrs({ variant: 'subtitle2' })`
  color: #000B1F;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.2px;
`;

export const StyledDialogContent = withStyles(() => ({
    root: {
        padding: 0,
        backgroundColor: '#f8f8f9'
    }
}))(DialogContent);

export const StyledDialogTitle = withStyles(() => ({
    root: {
        padding: '30px',
        paddingLeft: '50px'
    }
}))(DialogTitle);
